import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { PageBanner } from '../components/PageBanner';
import { PromoBanner } from '../components/PromoBanner';
import { BookingCTA } from '../components/BookingCTA';
import { Button } from '../components/ui/Button';
const categories = [{
  id: 'all',
  name: 'All Services'
}, {
  id: 'braids',
  name: 'Braids'
}, {
  id: 'locs',
  name: 'Locs'
}, {
  id: 'twisted',
  name: 'Twisted Hair Styles'
}, {
  id: 'protective',
  name: 'Protective Hair Styles'
}, {
  id: 'straight',
  name: 'Straight Hair Styles'
}];
const services = [{
  id: 1,
  category: 'braids',
  title: 'Knotless Braids',
  price: 'From $180',
  description: 'Pain-free, lightweight braids that protect your edges',
  image: 'https://cdn.magicpatterns.com/uploads/vuTG195XiLqBgVUgSo55rG/istockphoto-1328500183-612x612.webp'
}, {
  id: 2,
  category: 'braids',
  title: 'Box Braids',
  price: 'From $150',
  description: 'Classic, timeless braids crafted with precision',
  image: 'https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp'
}, {
  id: 3,
  category: 'braids',
  title: 'Cornrows',
  price: 'From $80',
  description: 'Intricate, neat designs from simple to complex patterns',
  image: 'https://cdn.magicpatterns.com/uploads/oPcjCp9rNhyi11miaW2wZo/istockphoto-1618291225-612x612.webp'
}, {
  id: 4,
  category: 'braids',
  title: 'Goddess Braids',
  price: 'From $165',
  description: 'Thick braids with curly ends for a bohemian look',
  image: 'https://cdn.magicpatterns.com/uploads/87rXMcBwVohMSGNCqWzK4j/istockphoto-1312551586-612x612.webp'
}, {
  id: 5,
  category: 'locs',
  title: 'Faux Locs',
  price: 'From $200',
  description: 'Beautiful locs without long-term commitment',
  image: 'https://cdn.magicpatterns.com/uploads/9HJ51oQBNvS7NQJc6RsA29/istockphoto-1370569973-2048x2048.jpg'
}, {
  id: 6,
  category: 'locs',
  title: 'Butterfly Locs',
  price: 'From $220',
  description: 'Trendy, lightweight distressed locs',
  image: 'https://cdn.magicpatterns.com/uploads/eGLo6DiTb719zndAEqfkfy/istockphoto-1370569973-2048x2048.jpg'
}, {
  id: 7,
  category: 'twisted',
  title: 'Senegalese Twists',
  price: 'From $160',
  description: 'Smooth, sleek two-strand twists',
  image: 'https://cdn.magicpatterns.com/uploads/tGErXKv5tYnexYUuxYDfJC/side-view-image-of-beautiful-braid-hair.jpg'
}, {
  id: 8,
  category: 'twisted',
  title: 'Passion Twists',
  price: 'From $180',
  description: 'Bohemian-style twists with a natural texture',
  image: 'https://cdn.magicpatterns.com/uploads/st4oeS41uakBMn5Py2Y32u/istockphoto-1333647263-612x612.webp'
}, {
  id: 9,
  category: 'protective',
  title: 'Crochet Braids',
  price: 'From $120',
  description: 'Quick, versatile protective styling',
  image: 'https://cdn.magicpatterns.com/uploads/8fkvPTEFH3AeLLB7R8gZQW/istockphoto-958683514-612x612.jpg'
}, {
  id: 10,
  category: 'protective',
  title: 'Silk Press',
  price: 'From $85',
  description: 'Sleek, straight finish while protecting natural hair',
  image: 'https://cdn.magicpatterns.com/uploads/2Rg35apmrhiBC7SirPQpSB/istockphoto-183341611-612x612.webp'
}, {
  id: 11,
  category: 'straight',
  title: 'Blow Out & Style',
  price: 'From $65',
  description: 'Professional blow dry and styling',
  image: 'https://cdn.magicpatterns.com/uploads/mYcGRmj7PyBLcwuLLFXpAV/istockphoto-183332797-612x612.webp'
}, {
  id: 12,
  category: 'straight',
  title: 'Flat Iron Press',
  price: 'From $75',
  description: 'Smooth, sleek straight look',
  image: 'https://cdn.magicpatterns.com/uploads/aQStPq7UhC3dBDPkZSknxz/istockphoto-1256553670-612x612.jpg'
}];
export function ServicesPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredServices = activeCategory === 'all' ? services : services.filter(s => s.category === activeCategory);
  return <>
      <PageBanner title="Our Services" subtitle="Expert braiding, locs, twists, and protective styles for all hair types" backgroundImage="https://cdn.magicpatterns.com/uploads/eq1mzaoV7yww71UG5f3y6M/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(2).jpg" data-id="element-638" />

      <PromoBanner data-id="element-639" />

      <section className="py-16 bg-white" data-id="element-640">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-641">
          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-642">
            {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory === cat.id ? 'bg-brand-gold text-white shadow-md' : 'bg-gray-100 text-jet hover:bg-brand-gold hover:text-white'}`} data-id="element-643">
                {cat.name}
              </button>)}
          </div>

          {/* Services Grid */}
          <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-644">
            <AnimatePresence mode="popLayout" data-id="element-645">
              {filteredServices.map((service, index) => <motion.div key={service.id} layout initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.3,
              delay: index * 0.05
            }} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-shadow duration-300 overflow-hidden group" data-id="element-646">
                  <div className="relative h-56 overflow-hidden" data-id="element-647">
                    <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-648" />
                    <div className="absolute inset-0 bg-gradient-to-t from-jet/50 to-transparent" data-id="element-649"></div>
                    <span className="absolute bottom-4 left-4 bg-brand-gold text-white px-3 py-1 text-sm font-bold rounded-full" data-id="element-650">
                      {service.price}
                    </span>
                  </div>
                  <div className="p-6" data-id="element-651">
                    <h3 className="text-xl font-heading font-bold text-jet mb-2" data-id="element-652">
                      {service.title}
                    </h3>
                    <p className="text-jet/60 mb-4 text-sm leading-relaxed" data-id="element-653">
                      {service.description}
                    </p>
                    <a href="tel:2409217857" className="block w-full" data-id="element-654">
                      <Button variant="outline" size="sm" className="w-full" data-id="element-655">
                        Call to Book
                      </Button>
                    </a>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <BookingCTA data-id="element-656" />
    </>;
}